module.exports = __webpack_public_path__ + "img/Chevron-Right_24px_2_Icon.c726411b.svg";